import {
    GET_VENDOR_BILL_CHART,
    SET_VENDOR_BILL_DROPDOWN,
    REMOVE_VENDOR_BILL_DROPDOWN,
    SET_VENDOR_BILL_FIELD,
    SET_VENDOR_BILL_LOADING,
    REMOVE_VENDOR_BILL_LOADING,
    CASECADE_STATUS_CODE,
    SET_ACCOUNTING_MATIX,
    SET_ACCOUNTING_MATIX_REF,
    SET_VENDOR_BILL_CLIN_DROPDOWN,
    SET_ACCOUNTING_MATIX_ASSOCIATIONS,
    SET_VENDOR_BILL_INVALID_SELECTION
} from "../../types";

const initialState = {
    chartData: [], // 	contains chart data
    dropdowns: {}, //	Dropdown list
    data: {}, //    Any default vaule here is used for vendor bill add
    accountingMatrix: [], // Accounting Matrix
    accountingMatrixRef: [], // Accounting MatrixRef
    accountingAssociations: [],
    clin_dropdown: [],
    orderLineItems: [], // orderLineItems
    invalidSelection: false,
    loading: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ACCOUNTING_MATIX:
            return {
                ...state,
                accountingMatrix: payload
            };
        case SET_ACCOUNTING_MATIX_REF: {
            return {
                ...state,
                accountingMatrixRef: payload
            };
        }
        case SET_ACCOUNTING_MATIX_ASSOCIATIONS: {
            return {
                ...state,
                accountingAssociations: payload
            };
        }
        case SET_VENDOR_BILL_CLIN_DROPDOWN: {
            return {
                ...state,
                dropdowns: {
                    ...state.dropdowns,
                    clin_dropdown: payload
                }
            };
        }
        case CASECADE_STATUS_CODE:
            return {
                ...state,
                dropdowns: {
                    ...state.dropdowns,
                    [payload.name]: payload.dropdown
                }
            };
        case SET_VENDOR_BILL_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_VENDOR_BILL_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_VENDOR_BILL_FIELD:
            return {
                ...state,
                data: { ...payload }
            };
        case GET_VENDOR_BILL_CHART:
            return {
                ...state,
                chartData: Object.values(payload),
                chartLoading: false
            };
        case SET_VENDOR_BILL_DROPDOWN:
            return {
                ...state,
                dropdowns: { ...payload }
            };
        case REMOVE_VENDOR_BILL_DROPDOWN:
            return {
                ...state,
                dropdowns: {}
            };
        case SET_VENDOR_BILL_INVALID_SELECTION:
            return {
                ...state,
                invalidSelection: payload
            };
        default:
            return state;
    }
}